import { put, select, takeEvery } from "redux-saga/effects";
import { ConsignmentModalSection, ModalTypes } from "constants/navigation";
import { getAgencyByDeploymentId, getNominationById } from "selectors";
import { updateModalContext } from "actions";
import { CREATE_CONSIGNMENT_FROM_NOMINATION } from "constants/actionTypes";
import { CreateConsignmentFromNominationAction } from "actions/modals/nomination";
import { openModalAndWait, SnapshotId, storeFormikSnapshot } from "./util";

function* createNewFromNomination(
  action: CreateConsignmentFromNominationAction,
) {
  const { nominationId, formikSnapshot } = action;
  // Store the current state of the form in the modal context
  // Close the nomination modal
  const snapshotId: SnapshotId = yield storeFormikSnapshot(
    ModalTypes.EditNomination,
    formikSnapshot,
  );
  const state = yield select();

  const nomination = getNominationById(nominationId)(state);

  const nominationHd =
    nomination?.nominationDetails?.reduce(
      (total, nominationDetail) => nominationDetail.quantity + total,
      0,
    ) || 0;

  const agencyId = getAgencyByDeploymentId(nomination.deploymentId)(state)?.id;

  const values = {
    nominationId,
    consignedFromId: nomination.consigningDeploymentId,
    vendor_id: nomination.vendorId,
    vendor_property_id: nomination.propertyId,
    quantity: nominationHd,
    agency_id: agencyId,
  };

  yield openModalAndWait({
    modalType: ModalTypes.Consignment,
    returnTo: window.location.hash,
    context: { values },
    urlArgs: { section: ConsignmentModalSection.GENERAL },
  });

  if (formikSnapshot) {
    yield put(
      updateModalContext(ModalTypes.EditNomination, { values: { snapshotId } }),
    );
  }
}

export function* nominationModalSagas() {
  yield takeEvery(CREATE_CONSIGNMENT_FROM_NOMINATION, createNewFromNomination);
}
